export default __webpack_public_path__ + "static/media/sn.8264ac13.svg";